import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Moment from 'react-moment';
import Pagination from "react-js-pagination";
import * as constant from '../../constants/constant';
import autoBind from 'auto-bind';
// import ShowMore from 'react-show-more';
// import '../../styles/css/style.css';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import * as SpecialistBlogActions from '../../actions/SpecialistblogActions.js';

class Blog extends React.Component {
	constructor(props, context) {
		super(props, context);
		autoBind(this);
		this.state = {
			allBlogList: [],
			FavouriteBlogList: [],
			recentBlog: [],
			activePage: 1,
			count: 10,
			sortColumnName: '',
			sortOrder: -1,
			searchText: '',
			tabCLicked: 1,
			blogType: 'specialist',
			isDisclaimer: localStorage.getItem('isDisclaimerBlog') ? true : false
		}
	}
	Capitalize(str) {
		if (str != '' && str != undefined)
			return str.charAt(0).toUpperCase() + str.slice(1);
		else
			return '';
	}

	goToDetailsPage(index) {
		let blogData = this.state.allBlogList[index];
		this.props.history.push({ pathname: `/dashboard/blogdetails/${blogData._id}/${this.state.blogType}`	});
	};
	goToDetailsFromFavPage(index) {
		let blogData = this.state.FavouriteBlogList[index];
		this.props.history.push(`/dashboard/blogdetails/${blogData.blogId}/${this.state.blogType}`);
	};
	goToDetailsFromRecPage(item) {
		// let blogData = this.state.recentBlog[index];
		let roles = item.roles == 3 ? 'admin': 'specialist';
		this.props.history.push(`/dashboard/blogdetails/${item._id}/${roles}`);
	}
	likeandUnLikeBlog(item) {
		//console.log(this.state.allBlogList, 'test1', item, "test2");
		// this.state.allBlogList.forEach(element => {
		// 	console.log(element, "ele")
		// 	if (element._id === item._id) {
		// 		if (item.isLiked) {
		// 			element.isLiked = true
		// 		} else {
		// 			element.isLiked = false
		// 		}
		// 		if (item.likeCount === 0) {
		// 			element.likeCount = element.likeCount + 1
		// 		}
		// 	}
		// });
		// this.setState({
		// 	allBlogList: this.state.allBlogList
		// })
		let object = {
			patientId: localStorage.getItem('userId'),
			specialistId: item.specialistId,
			blogId: item._id
		}
		let tableObject = {
			page: this.state.activePage,
			count: this.state.count,
			type: item.roles == 3 ? 'admin' : 'specialist',
		}
		this.props.actions.likeandUnLikeBlog(object, tableObject);
		// let objectt = {
		// 	page: this.state.activePage,
		// 	count: this.state.count,
		// 	type: item.roles == 3 ? 'admin' : 'specialist',
		// }
		// this.props.actions.getAllBlogList(objectt)
	}
	favouriteAndUnFavouriteBlog(item) {

		let object = {
			patientId: localStorage.getItem('userId'),
			specialistId: item.specialistId,
			blogId: item._id
		}
		let tableObject = {
			page: this.state.activePage,
			count: this.state.count,
			// type: item.roles == 3 ? 'admin' : 'specialist',
			type: this.state.blogType
		}
		this.props.actions.favouriteAndUnFavouriteBlog(object, tableObject);

	}
	favouriteAndUnFavouriteBlogPage(item) {
		let object = {
			patientId: localStorage.getItem('userId'),
			specialistId: item.specialistId,
			blogId: item.blogId
		}
		let tableObject = {
			page: this.state.activePage,
			count: this.state.count,
		}
		this.props.actions.favouriteAndUnFavouriteBlog(object, tableObject);

	}
	// searchText
	search(event) {
		this.setState({
			[event.target.name]: event.target.value
		});
		if (event.target.value.length > 3 || event.target.value == '') {
			let object = {
				count: 10,
				page: 1,
				searchText: event.target.value,
				type: this.state.blogType
			};
			this.props.actions.getAllBlogList(object);
		}
	}
	componentWillMount() {

		let object = {
			page: this.state.activePage,
			count: this.state.count,
			type: this.state.blogType,
		}
		console.log("s[eco;aostsjdklfjsdf==>>", object)
		this.props.actions.getAllBlogList(object)
	}
	componentDidMount() {
		if (localStorage.getItem('isDisclaimerBlog') == 'true') {
			confirmAlert({
				customUI: ({ onClose }) => {
					return (
						<div className='custom-ui disclaimer_appointement'>
							<a style={{ cursor: "pointer" }} className="closeBtn" onClick={onClose}></a>

							<h1>Disclaimer</h1>
							{/* <p> {nextProps.convertedCurrency.query.amount} {nextProps.convertedCurrency.query.from} = {currancy} {localStorage.getItem('currency')}</p> */}
							<span>The blog posts published by medical specialists on the Medfix website are based on professional medical opinion at the time they are published.  They are not a substitute for general medical advice and the diagnosis and treatment of illnesses, ailments or conditions and should not be relied on for these purposes.  Where medical opinion differs, we recommend you seek the advice of a medical practitioner.  Any information given is done so in good faith but does not take into account any individual circumstances or constraints.</span>
							<div className="bottomBtn text-center"><button type="button" onClick={onClose} className="btn btn-warning btn-lg">Ok</button></div>
						</div>
					)
				}
			})
			localStorage.setItem('isDisclaimerBlog', false);
			console.log("false")
		}
		// 	if(this.state.isDisclaimer){
		// 	confirmAlert({
		// 		customUI: ({ onClose }) => {
		// 			return (
		// 				<div className='custom-ui disclaimer_appointement'>
		// 				<a  style={{ cursor: "pointer" }} className="closeBtn" onClick={onClose}></a>

		// 					<h1>Disclaimer</h1>
		// 					{/* <p> {nextProps.convertedCurrency.query.amount} {nextProps.convertedCurrency.query.from} = {currancy} {localStorage.getItem('currency')}</p> */}
		// 					<span>The blog posts published by medical specialists on the Medfix website are based on professional medical opinion at the time they are published.  They are not a substitute for general medical advice and the diagnosis and treatment of illnesses, ailments or conditions and should not be relied on for these purposes.  Where medical opinion differs, we recommend you seek the advice of a medical practitioner.  Any information given is done so in good faith but does not take into account any individual circumstances or constraints.</span>
		// 					<div className="bottomBtn text-center"><button type="button"  onClick={onClose}	 className="btn btn-warning btn-lg">Ok</button></div>
		// 				</div>
		// 			)
		// 		}
		// 	})
		// 	localStorage.setItem('isDisclaimerBlog','')
		// }
	}
	componentWillReceiveProps(nextProps) {
		//  ;
		// console.log("nextProp ++++++++++++++++++++++>", nextProps)
		if (nextProps.success) {
			this.setState({
				allBlogList: nextProps.allBlogList,
				recentBlog: nextProps.recentBlog,
				totalCount: nextProps.totalCount,
				FavouriteBlogList: nextProps.FavouriteBlogList,
				FavouriteBlogTotalCount: nextProps.FavouriteBlogTotalCount,
				isLoader: false
			})
		} else {
			this.setState({
				isLoader: false
			})
		}

		if (localStorage.getItem('isClicked') === "true") {
			localStorage.removeItem('isClicked')

			this.setState({
				tabCLicked: 1
			})
			this.onChangeTab(1);
		}
	}
	goToSpecialistDetailsPage(index, availabilitiesId) {

		this.props.history.push('/specialist-details/' + availabilitiesId);
	};
	handlePageChange(pageNumber) {
		this.setState({ activePage: pageNumber });
		let object = {
			page: pageNumber,
			count: this.state.count,
			type: this.state.blogType
		}
		this.props.actions.getAllBlogList(object);
	}

	onChangeTab(data) {

		this.setState({
			activePage: 1,
			tabCLicked: data
		});
		let object = {
			page: 1,
			count: 10,
			type: this.state.blogType
		}
		this.props.actions.getAllBlogList(object);
	}

	onBlogChangeTab(data) {

		this.setState({
			activePage: 1,
			blogType: data
		}, () => {
			let object = {
				page: 1,
				count: 10,
				type: data,
			}
			this.props.actions.getAllBlogList(object);
		});
	}

	render() {
		const { allBlogList, recentBlog, FavouriteBlogList } = this.props;
		let blogList = []
		let recentBlogList = []
		let favouriteBlogList = []
		// if (allBlogList) {
			// var defaultImagePath =
			// 	constant.PRODUCTION_IMAGE_URL + "uploads/common/noUserImage.jpg";
			this.state.allBlogList.forEach(function (item, index) {
				var defaultImagePath = item.gender == 'Male' ? constant.PRODUCTION_IMAGE_URL + 'uploads/' + constant.COMMON_FOLDER + 'doctor_m.png' : constant.PRODUCTION_IMAGE_URL + 'uploads/' + constant.COMMON_FOLDER + 'doctor_f.png';
	
				let profileImage, listImage
				if (item && item.profileImage && item.profileImage != '' && item.profileImage != 'noUserImage.jpg') {
					profileImage = constant.PRODUCTION_IMAGE_URL + 'uploads/' + item.specialistId + '/' + item.profileImage
				} else {
					profileImage = item.gender == 'Male' ? constant.PRODUCTION_IMAGE_URL + 'uploads/' + constant.COMMON_FOLDER + 'doctor_m.png' : constant.PRODUCTION_IMAGE_URL + 'uploads/' + constant.COMMON_FOLDER + 'doctor_f.png';
				}
				if (item && item.listImage && item.listImage != '' && item.listImage != 'blog_dflt.png') {
					listImage = constant.PRODUCTION_IMAGE_URL + 'uploads/' + item.specialistId + '/' + item.listImage
				} else {
					listImage = constant.PRODUCTION_IMAGE_URL + 'uploads/' + 'common' + '/' + item.listImage
				}
				blogList.push(<div className="tab-pane active" >
					<div className="blogListings" key={index}>
						<div className="blogImg"> <img className="" src={listImage} alt="User profile picture" onError={e => {
							e.target.src = defaultImagePath;
						}} /> </div>
	
						<div className="blogTime">
							<i className="fa fa-fw fa-clock-o"></i><Moment format="DD-MMM-YYYY">{item.createdAt}</Moment>
						</div>
						<h2 className="text-capitalize">{item.blogTitle}</h2>
						<div className="drInfo">
							<div className="imgBtmLine" style={{ 'cursor': 'pointer' }} onClick={this.goToSpecialistDetailsPage.bind(this, index, item.availabilitiesInfo[0])}>  <img src={profileImage} onError={e => {
								e.target.src = defaultImagePath;
							}} /></div>
	
							<div className="drName text-capitalize" style={{ 'cursor': 'pointer' }} onClick={this.goToSpecialistDetailsPage.bind(this, index, item.availabilitiesInfo[0])}>{item.roles == 3 ? 'Medfix Team' : "Dr. " + item.userName}</div>
							<div className="drEdu">
								<p>{item.specializationName} | {item.gender}</p>
								<p>{item.academics}</p><p>{item.qualification}</p>
							</div>
	
							<div className="clearfix"></div>
	
						</div>
	
						<div className="Blogtext" dangerouslySetInnerHTML={{ __html: item.description }}>
						</div>
						<Link className="readMore" style={{ 'cursor': "pointer" }} onClick={this.goToDetailsPage.bind(this, index)}>READ dMORE &gt; </Link>
	
	
	
						<span style={{ 'cursor': "pointer" }}>
							{item && item.isLiked ?
								<Link onClick={this.likeandUnLikeBlog.bind(this, item)}
									className="readMore"><img src={require('../../images/img/like_active.png')}
									/></Link>
								:
								<Link onClick={this.likeandUnLikeBlog.bind(this, item)}
									className="readMore"><img src={require('../../images/img/like.png')}
									/></Link>} </span>
	
	
	
						<span style={{ fontSize: 12 }}> {item.likeCount} Likes</span>
						<span style={{ marginLeft: 7, 'cursor': "pointer" }}>
							{item && item.isFavourite ?
								<Link onClick={this.favouriteAndUnFavouriteBlog.bind(this, item)}
									className="readMore">
									<img src={require('../../images/start_icon.png')} /></Link>
								:
								<Link onClick={this.favouriteAndUnFavouriteBlog.bind(this, item)}
									className="readMore"><img src={require('../../images/start_icon_off.png')} /></Link>}
						</span>
	
						{/* <Link onClick={this.likeandUnLikeBlog.bind(this, item)} className="readMore"><img src={require('../../images/img/like_active.png')} /></Link>
						<Link onClick={this.likeandUnLikeBlog.bind(this, item)} className="readMore"><img src={require('../../images/img/like.png')} /></Link>
						<Link onClick={this.favouriteAndUnFavouriteBlog.bind(this, item)} className="readMore"><img src={require('../../images/img/fav.png')} /></Link>
						<Link onClick={this.favouriteAndUnFavouriteBlog.bind(this, item)} className="readMore"><img src={require('../../images/img/fav_active.png')} /></Link> */}
					</div>
				</div>)
			}.bind(this));
			this.state.recentBlog.forEach(function (item, index) {
				recentBlogList.push(<li><Link onClick={this.goToDetailsFromRecPage.bind(this, item)} style={{ 'cursor': "pointer" }}>{item.blogTitle},<p className='marginbottom0'> By <span className="text-capitalize">{item.roles == 3 ? "Medfix Team" : "Drddd. " + item.userName}</span></p></Link></li>)
			}.bind(this));
			this.state.FavouriteBlogList.forEach(function (item, index) {
				var profileImage, listImage
				var defaultImagePath = item.userGender == 'Male' ? constant.PRODUCTION_IMAGE_URL + 'uploads/' + constant.COMMON_FOLDER + 'doctor_m.png' : constant.PRODUCTION_IMAGE_URL + 'uploads/' + constant.COMMON_FOLDER + 'doctor_f.png';
	
				if (item && item.profileImage && item.profileImage != '' && item.profileImage != 'noUserImage.jpg') {
					profileImage = constant.PRODUCTION_IMAGE_URL + 'uploads/' + item.specialistId + '/' + item.profileImage
				} else {
					profileImage = item.userGender == 'Male' ? constant.PRODUCTION_IMAGE_URL + 'uploads/' + constant.COMMON_FOLDER + 'doctor_m.png' : constant.PRODUCTION_IMAGE_URL + 'uploads/' + constant.COMMON_FOLDER + 'doctor_f.png';
				}
				if (item && item.listImage && item.listImage != 'noUserImage.jpg') {
					listImage = constant.PRODUCTION_IMAGE_URL + 'uploads/' + item.specialistId + '/' + item.listImage
				}
				else {
					item.userGender == 'Male' ? constant.PRODUCTION_IMAGE_URL + 'uploads/' + constant.COMMON_FOLDER + 'doctor_m.png' : constant.PRODUCTION_IMAGE_URL + 'uploads/' + constant.COMMON_FOLDER + 'doctor_f.png';
	
				}
				favouriteBlogList.push(<div className="tab-pane active" >
					<div className="blogListings">
						<div className="blogImg"> <img className="" src={listImage} alt="User profile picture" onError={e => {
							e.target.src = defaultImagePath;
						}} /> </div>
	
						<div className="blogTime">
							<i className="fa fa-fw fa-clock-o"></i><Moment format="DD-MMM-YYYY">{item.createdAt}</Moment>
						</div>
						<h2 className="text-capitalize">{item.blogTitle}</h2>
						<div className="drInfo">
							<div className="imgBtmLine" style={{ 'cursor': 'pointer' }} onClick={this.goToSpecialistDetailsPage.bind(this, index, item.availabilitiesInfo[0])}>  <img src={profileImage} onError={e => {
								e.target.src = defaultImagePath;
							}} /></div>
	
							<div className="drName text-capitalize" style={{ 'cursor': 'pointer' }} onClick={this.goToSpecialistDetailsPage.bind(this, index, item.availabilitiesInfo[0])}>{item.roles == 3 ? 'Medfix Team' : "Dr. " + item.userName}</div>
							<div className="drEdu"><p>{item.academics}</p><p>{item.qualification}</p></div>
							<div className="clearfix"></div>
	
						</div>
	
						{/* <p><ShowMore className="readMore"
							lines={3}
							more={<span className="readMore">READ MORE &gt;</span>}
							less={<span className="readMore">&lt; READ LESS</span>}
							anchorClass=''
						>
							{item.description}
						</ShowMore>
						</p> */}
						<div className="Blogtext" dangerouslySetInnerHTML={{ __html: item.description }}>
						</div>
						<Link to="#" className="readMore" style={{ "cursor": "pointer" }} onClick={this.goToDetailsFromFavPage.bind(this, index)}>READ MORE &gt;</Link>
	
						{/* <span>{item && item.isLiked ? <Link onClick={this.likeandUnLikeBlog.bind(this, item)} className="readMore"><img src={require('../../images/img/like_active.png')} /></Link> : <Link onClick={this.likeandUnLikeBlog.bind(this, item)} className="readMore"><img src={require('../../images/img/like.png')} /></Link>} </span>
						<span  style={{fontSize:12}}> {item.likeCount} Likes</span> */}
						<span style={{ marginLeft: 7, 'cursor': "pointer" }}>{item && item.isFavourite ? <Link onClick={this.favouriteAndUnFavouriteBlogPage.bind(this, item)} className="readMore"><img src={require('../../images/img/fav_active.png')} /></Link> : <Link onClick={this.favouriteAndUnFavouriteBlogPage.bind(this, item)} className="readMore"><img src={require('../../images/img/fav.png')} /></Link>} </span>
	
						{/* <Link onClick={this.likeandUnLikeBlog.bind(this, item)} className="readMore"><img src={require('../../images/img/like_active.png')} /></Link>
						<Link onClick={this.likeandUnLikeBlog.bind(this, item)} className="readMore"><img src={require('../../images/img/like.png')} /></Link>
						<Link onClick={this.favouriteAndUnFavouriteBlog.bind(this, item)} className="readMore"><img src={require('../../images/img/fav.png')} /></Link>
						<Link onClick={this.favouriteAndUnFavouriteBlog.bind(this, item)} className="readMore"><img src={require('../../images/img/fav_active.png')} /></Link> */}
					</div>
				</div>)
			}.bind(this));

		// }
		return (
			<div className="content-wrapper">
				<section className="content container-fluid">
					<div className="row">
						<div className="col-md-12">
							<div className="boxMrgB">
								<div className="nav-tabs-custom">
									<ul className="nav nav-tabs">
										<li ><Link href="#tab_1" onClick={this.onChangeTab.bind(this, 1)} data-toggle="tab" className={this.state.tabCLicked === 1 ? "active show" : ''}>Blog</Link></li>
										<li><Link href="#tab_2" onClick={this.onChangeTab.bind(this, 2)} data-toggle="tab" className={this.state.tabCLicked === 2 ? "active show" : ''}>My Favourites </Link></li>
									</ul>
									<ul className="nav nav-tabs">
										<li ><Link href="#tab_1" onClick={this.onBlogChangeTab.bind(this, 'specialist')} data-toggle="tab" className={this.state.blogType == 'specialist' ? "active show" : ''}>Specialist</Link></li>
										<li><Link href="#tab_2" onClick={this.onBlogChangeTab.bind(this, 'medfix')} data-toggle="tab" className={this.state.blogType === 'medfix' ? "active show" : ''}>Medfix Team </Link></li>
									</ul>
									<div className="tab-content blogContent">
										<div className={this.state.tabCLicked === 1 ? " tab-pane active show" : 'tab-pane'} id="tab_1">
											<div className="row">
												<div className="col-md-9 active ">
													<div className="tab-content tabother searchSpe collapResults blogListings">

														{blogList && blogList.length > 0 ? blogList : <div class="tab-content tabother searchSpe collapResults blogListings" className="text-center" >No Blogs Here yet ! </div>}
														{(blogList && blogList.length > 0) ?
															<div className="row" style={{ 'marginTop': 30 }}>
																<div className="col-sm-5"><div className="showingEntries">Showing {(this.state.activePage * this.state.count) - (this.state.count - 1)} to {(this.state.activePage * this.state.count) > this.state.totalCount ? this.state.totalCount : (this.state.activePage * this.state.count)} of {this.state.totalCount} entries</div></div>
																<div className="col-sm-7 text-right" style={{ "cursor": "pointer" }}>
																	<Pagination
																		prevPageText='Prev'
																		nextPageText='Next'
																		hideFirstLastPages
																		activePage={this.state.activePage}
																		itemsCountPerPage={10}
																		pageRangeDisplayed={10}
																		totalItemsCount={this.state.totalCount}
																		onChange={this.handlePageChange.bind(this)}
																	/>

																</div>

															</div> : ''}
													</div>
												</div>


												<div className="col-md-3">
													<div className="tab-content tabother blogBg">
														<div className="row">
															<div className="col-sm-12">
																<div className="searchBlog">

																	<i className="fa fa-search"></i>
																	{/* <input type="text" placeholder="search" /> */}
																	<input type="text" name="searchText" onChange={this.search.bind(this)} value={this.state.searchText} placeholder="Search" />
																</div>
																<div className="searchblogList"><h2>RECENT POSTS</h2>
																	<ul className='capitalize'>{recentBlogList && recentBlogList.length > 0 ? recentBlogList : ''}
																	</ul>
																</div>

															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
										{/* <!-- /.tab-pane --> */}
										<div className={this.state.tabCLicked === 2 ? " tab-pane active show" : 'tab-pane'} id="tab_2"> <div className="row">
											<div className="col-md-12 active ">
												<div className="tab-content tabother searchSpe collapResults blogListings">

													{favouriteBlogList && favouriteBlogList.length > 0 ? favouriteBlogList : <div class="tab-content tabother searchSpe collapResults blogListings" ><h2 className="subTitle textcenter text-transformation"> There are No Favourite Blogs Yet !</h2></div>}
													{(favouriteBlogList && favouriteBlogList.length > 0) ?
														<div className="row" style={{ 'marginTop': 30 }}>
															<div className="col-sm-5">Showing {(this.state.activePage * this.state.count) - (this.state.count - 1)} to {(this.state.activePage * this.state.count) > this.state.FavouriteBlogTotalCount ? this.state.FavouriteBlogTotalCount : (this.state.activePage * this.state.count)} of {this.state.FavouriteBlogTotalCount} entries</div>
															<div className="col-sm-7 text-right" style={{ "cursor": "pointer" }}>
																<Pagination
																	prevPageText='Prev'
																	nextPageText='Next'
																	hideFirstLastPages
																	activePage={this.state.activePage}
																	itemsCountPerPage={10}
																	pageRangeDisplayed={10}
																	totalItemsCount={this.state.FavouriteBlogTotalCount}
																	onChange={this.handlePageChange.bind(this)}
																/>

															</div>

														</div> : ''}
												</div>
											</div>


											{/* <div className="col-md-3">
													<div className="tab-content tabother blogBg">
														<div className="row">
															<div className="col-sm-12">
																<div className="searchBlog">

																	<i className="fa fa-search"></i>
																	<input type="text" name="searchText" onChange={this.search.bind(this)} value={this.state.searchText} placeholder="Search" />

																</div>
																<div className="searchblogList"><h2>RECENT POSTS</h2>

																	<ul>{recentBlogList && recentBlogList.length > 0 ? recentBlogList : ''}
																	</ul>
																</div>

															</div>
														</div>
													</div>
												</div> */}
										</div> </div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>

				<div className="Copyrightafterlogin">
					<p>Medfix &copy; 2018. All rights reserved</p>

				</div>
			</div>
		);
	}
}

//this tells what state should expose on props
function mapStateToProps(state, ownProps) {
	return {
		allBlogList: state.SpecialistBlog.allBlogList ? state.SpecialistBlog.allBlogList.data : [],
		totalCount: state.SpecialistBlog.allBlogList ? state.SpecialistBlog.allBlogList.totalCount : 0,
		success: state.SpecialistBlog.allBlogList ? state.SpecialistBlog.allBlogList.success : false,
		recentBlog: state.SpecialistBlog.allBlogList ? state.SpecialistBlog.allBlogList.recentBlog : [],
		FavouriteBlogList: state.SpecialistBlog.allBlogList ? state.SpecialistBlog.allBlogList.FavouriteBlogData : [],
		FavouriteBlogTotalCount: state.SpecialistBlog.allBlogList ? state.SpecialistBlog.allBlogList.totalCountFavouriteblog : 0,

	};
}
//this tells what action should expose on props
//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(SpecialistBlogActions, dispatch),
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(Blog);
